// extracted by mini-css-extract-plugin
module.exports = {"page":"ProductsDevices_page_2DXaY","pagination":"ProductsDevices_pagination_2Z0L8"};